export type RouteDef = {
  name: string
  path: string
}

export const routesDef = {
  HomePage: {
    name: 'Home',
    path: '/',
  },
  DeleteAccount: {
    name: 'Delete Account',
    path: '/delete_account',
  },
  JoinSchool: {
    name: 'Join School',
    path: '/join-school',
  },
  Privacy: {
    name: 'Privacy Policy',
    path: '/privacy',
  },
  Terms: {
    name: 'Terms and Conditions',
    path: '/terms',
  },
  // The authenticated support area — rendered client-side only (see pages/support/index.tsx).
  // SupportDetail's path shape is load-bearing: support emails already sent link to
  // `/support/tickets/<old ticket id>`, so this route keeps resolving at that shape. `:_id` is the
  // conversation's `externalId`, which a migrated conversation sets to its old ticket id. A
  // conversation is started from the list's Contact Us panel, so there is no separate "new
  // request" route.
  SupportSignIn: {
    name: 'Support Sign In',
    path: '/support/login',
  },
  SupportList: {
    name: 'Support Requests',
    path: '/support',
  },
  SupportDetail: {
    name: 'Support Request',
    path: '/support/tickets/:_id',
  },
  // Lands the passwordless/basic sign-in redirect — WebsiteRouter.ts (API) builds this exact
  // path (`${rootUrl}/auth/success/<payload>`), mirroring apps/quickscore/admin/src/config/
  // routes.ts:97-101's AuthSuccessPage. Reachable with no session (it is what creates one), so
  // it stays OUTSIDE the /support/* mount RequireSupportSession guards.
  AuthSuccess: {
    name: 'Auth Success',
    path: '/auth/success/:auth',
  },
  Help: {
    name: 'Help',
    path: '/help',
  },
  HelpArticle: {
    name: 'Help Article',
    path: '/help/:slug',
  },
  NotFound: {
    name: 'Not Found',
    path: '*',
  },
} satisfies Record<string, RouteDef>

// `_id` is the conversation's external id, the key the thread reads on (as in the PanelPunches
// store's /account/messages/:_id).
export const buildSupportTicketPath = (_id: string): string => `/support/tickets/${_id}`

// In-page section anchors for the single landing route. Consumed by the sticky
// nav and CTAs. IDs match the approved prototype's section ids verbatim
// (docs/quickscore/spec/2026-07-21-feature-1248-quickscore-landing.prototype.html).
export const sectionAnchors = {
  features: '#features',
  howItWorks: '#how',
  whatItReads: '#reads',
  pricing: '#pricing',
  faq: '#faq',
  contact: '#contact',
} as const
